import axios from "axios";

// Autenticazione via cookie httpOnly (access_token/refresh_token) con withCredentials.
// Nessun token sensibile viene memorizzato in localStorage (mitigazione XSS).
const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  timeout: 30000,
});

export function formatApiError(e) {
  if (e?.code === "ECONNABORTED") {
    return "L'operazione sta richiedendo più tempo del previsto. Se era una generazione, continua in background: controlla lo stato dalla pagina.";
  }
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Errore imprevisto. Riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (typeof d?.msg === "string") return d.msg;
  if (typeof d?.message === "string") return d.message;
  return String(d);
}

export default api;
